import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  cardHeader: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.header,
    color: theme.palette.text.secondary,
    ...theme.typography.button,
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(1),
    },
  },
  cardHeaderText: {
    ...theme.typography.button,
  },
  headerTitle: {
    textAlign: "left",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
  headerAddButton: {
    textAlign: "right",
    justifyContent: "right",
    flexDirection: "column",
  },
  addButton: {},
  tableContainer: {
    padding: "1% 3% 1% 3%",
    overflowX: "auto",
  },
  paginationTop: {
    display: "flex",
    justifyContent: "flex-end",
    borderBottom: "none",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    tableLayout: "fixed",
    "& th": {
      textAlign: "left",
      padding: theme.spacing(1, 1.5),
      borderBottom: `2px solid ${theme.palette.divider}`,
      fontSize: 12,
      fontWeight: 700,
      color: theme.palette.text.primary,
      letterSpacing: "0.5px",
      whiteSpace: "nowrap",
      cursor: "pointer",
      userSelect: "none",
      "&:hover": {
        color: theme.palette.text.primary,
      },
      "&:last-child": {
        width: 160,
        cursor: "default",
      },
    },
    "& td": {
      padding: theme.spacing(1, 1.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
      verticalAlign: "middle",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      maxWidth: 0,
      "&:last-child": {
        overflow: "visible",
        whiteSpace: "nowrap",
        width: 160,
        maxWidth: "none",
      },
    },
    "& tbody tr": {
      "&:hover": { backgroundColor: theme.palette.action.hover },
    },
    [theme.breakpoints.down("sm")]: {
      tableLayout: "auto",
      "& thead": {
        position: "absolute",
        top: -9999,
        left: -9999,
      },
      "& tbody tr": {
        display: "block",
        marginBottom: theme.spacing(1.5),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
      },
      "& td": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: `1px solid ${theme.palette.divider}`,
        overflow: "visible",
        whiteSpace: "normal",
        maxWidth: "none",
        "&::before": {
          content: "attr(data-column)",
          fontWeight: 700,
          fontSize: 11,
          textTransform: "uppercase",
          color: theme.palette.text.secondary,
          letterSpacing: "0.5px",
          marginRight: theme.spacing(1),
          flexShrink: 0,
        },
        "&:last-child": {
          justifyContent: "flex-end",
          gap: theme.spacing(1),
          width: "auto",
          "&::before": {
            display: "none",
          },
        },
      },
    },
  },
  sortIcon: {
    fontSize: 14,
    marginLeft: theme.spacing(0.5),
    verticalAlign: "middle",
  },
  drawerPaper: {
    width: 400,
    overflow: "hidden",
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  drawerInner: {
    display: "grid",
    gridTemplateRows: "56px 1px 1fr 1px 64px",
    height: "100vh",
    maxHeight: "100%",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 2),
    overflow: "hidden",
    "& h6": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  drawerBody: {
    overflowY: "auto",
    padding: theme.spacing(2),
  },
  drawerFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    padding: theme.spacing(0, 2),
  },
  deleteBtn: {
    color: theme.palette.error.main,
    "&:hover": { backgroundColor: "rgba(231, 0, 34, 0.08)" },
  },
  rewardTierRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  rewardTierInfo: {
    display: "flex",
    flexDirection: "column",
  },
  rewardTierActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(8, 2),
    textAlign: "center",
  },
  backdrop: {
    background: "rgba(0, 0, 0, 0.65)",
    backdropFilter: "blur(4px)",
  },
  tiersSection: {
    marginTop: theme.spacing(2),
  },
  tiersSectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1),
  },
  chipsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 4,
  },
  // RewardModal styles
  modalEqualsSeparator: {
    paddingTop: 24,
  },
  modalActions: {
    marginTop: theme.spacing(2),
  },
  modalCancelBtn: {
    backgroundColor: "#e0e0e0",
    color: "#000",
  },
  // RewardGroupsList styles
  listDeleteBtn: {
    marginLeft: 4,
  },
  defaultChip: {
    marginLeft: theme.spacing(1),
  },
  // RewardGroupsContainer styles
  containerPaper: {
    width: "100%",
  },
  deleteDialogNoBtn: {
    backgroundColor: "#d32f2f",
    color: "#fff",
  },
  // RewardGroupDrawer styles
  tiersPagination: {
    marginTop: theme.spacing(1),
    display: "flex",
    justifyContent: "center",
  },
  emailDomainInputRoot: {
    paddingLeft: "0 !important",
  },
  emailDomainTextInput: {
    paddingLeft: "5px !important",
  },
  emailDomainAdornment: {
    alignSelf: "stretch",
    flex: "0 0 10%",
    width: "10%",
    minWidth: "10%",
    height: "auto",
    maxHeight: "none",
    marginLeft: 0,
    marginRight: 0,
    justifyContent: "center",
    borderRight: `1px solid ${theme.palette.divider}`,
    boxSizing: "border-box",
    color: theme.palette.text.primary,
    fontWeight: 500,
  },
}));

export default useStyles;
